export default __webpack_public_path__ + "static/media/house-of-stitched.0972e24e.jpg";